import "./css/app.scss"
import accordian from "./ts/accordian"
import blogSliders from "./ts/blogSleders"
import copyAdv from "./ts/copyAdv"
import dropdown from "./ts/dropdowns"
import lazyLoad from "./ts/lazyLoad"
import loadSprite from "./ts/loadSprite"
import mobMenu from "./ts/mobMenu"
import "./ts/neto.js"
import popups from "./ts/popups"
import preventAddToCart from "./ts/preventAddToCart"
import readMore from "./ts/readmore"
import sliders from "./ts/slider"
import stickyHeader from "./ts/stickyHeader"
import storefinder from "./ts/storeFinder"
import textChange from "./ts/textChange"
import videos from "./ts/videos"
import brandTrigger from "./ts/brandsTriggers" 

sliders.init()
loadSprite.init()
accordian.init()
dropdown.init()
popups.init()
lazyLoad.init()
copyAdv.init()
readMore.init()
mobMenu.init()
blogSliders.init()
storefinder.init()
videos.init()
stickyHeader.init()
preventAddToCart.init()
textChange.init()
brandTrigger.init()
window.resetEvent = new Event("reset")
